import React from 'react';

interface DlpFieldProps {
    label: string;
    hint?: string;
    children: React.ReactNode;
}

export function DlpField({ label, hint, children }: DlpFieldProps) {
    return (
        <div className="field">
            <div className="field-label">{label}{hint && <span className="field-hint"> · {hint}</span>}</div>
            {children}
        </div>
    );
}
